import React from 'react'
import Skeleton from 'react-loading-skeleton'
import classnames from 'classnames'

import useStyles from './style'

function SkeletonProgressBar({ className }) {
  const classes = useStyles()

  return <Skeleton className={classnames(classes.progressBar, className)} width="100%" />
}

export default SkeletonProgressBar
